module.exports = __webpack_public_path__ + "img/LNB_hand.9f90951b.svg";